
import { ALL_METALS, ADD_NEW_METAL, UPDATE_METAL, DELETE_METAL, FETCH_METALS_BY_USER, FETCH_METAL, START_LOADING, END_LOADING } from '../actions/constants'

const metals = (state = { isLoading: true, metals: [] }, action) => {
    switch (action.type) {
      case START_LOADING:
        return { ...state, isLoading: true };
      case END_LOADING:
        return { ...state, isLoading: false };
      case ALL_METALS:
        return { ...state, metals: action.payload };
      case FETCH_METALS_BY_USER:       
        return { ...state, metals: action.payload };

      case FETCH_METAL:
        return { ...state, metal: action.payload.metal };
      case ADD_NEW_METAL:
        return { ...state, metals: [...state.metals, action.payload] };
      case UPDATE_METAL:
        return { ...state, metals: state.metals.map((metal) => (metal.id === action.payload.id ? action.payload : metal)) };
      case DELETE_METAL:
        return { ...state, metals: state.metals.filter((metal) => metal.id !== action.payload) };
      default:
        return state;
    }
  };

  export default metals


